const globalDS = {
    modelOpen: false,
    'civilian-chemical': {
        subTitle: 'Threat scenario',
        title: 'Chemical terrorist attack',
        steps: {
            intro: `
                <p>In this scenario – a terrorist event in a crowded metro station – we see how Saab’s complete CBRN solution comes together to coordinate support and ensure a joined-up response.</p>`,
            step1: `
                <p>An underground metro station during the busy morning rush hour.</p>
                <p>A terrorist, secretly carrying a canister, approaches and enters.</p>`,
            step2: `
                <p>Once on the platform, the terrorist covertly dumps a chemical canister, before boarding a train and escaping the station.</p>
                <p>The canister starts to spread a nerve agent.</p>
                <p>The station’s integrated sensors detect the threat right away and display what kind of substance the agent is. They transmit a signal to the Stationary Area Detection (SAD) system.</p>
                <p>An alarm is activated in the offsite control centre.</p>`,
            step3: `
                <p>The control centre receives signals from SAD systems in stations throughout the area.</p>
                <p>Here, operators can contact the emergency services and coordinate a rescue and decontamination response.</p>
                <p>Police come to the train station and enter, with hand-held sensors and gas mask on. Police seal off station.</p>`,
            step4: `
                <p>In the control centre, the operator receives on-screen information and step-by-step guidance.</p>
                <p>Alerts are automatically transmitted to police, transport operators and the fire department.</p>
                <p>People in the station are starting to be affected by the nerve agent.</p>
                <p>Rescue services arrive on the scene, and make sure the station is contained. </p>`,
            step5: `
                <p>People in the station are ordered to leave the platform immediately. The transport operator stops inbound and outbound trains, to stop air flow and reduce the spread of the threat. This also stops the flow of people.</p>
                <p>The operator in the control centre monitors the situation using a network of charge-coupled device (CCD) cameras.</p>
                <p>The station operator closes air ventilation, to stop the spread of infection.</p>
                <p>All those possibly affected are isolated and treated.</p>`,
            step6: `
                <p>The rescue agencies send in available teams, wearing protective suits.</p>
                <p>Right away the teams start to help injured people and transport them from the platform.</p>
                <p>The Personal Area Detection (PAD) system is used and is connected to the control centre.</p>`,
            step7: `
                <p>The HAZMAT team arrives to the scene and enters the station to take samples for identification.</p>
                <p>The team brings sampling equipment and chemical sensors to provide provisional identification of the substance.</p>`,
            step8: `
                <p>The Fire and Rescue department sends fast response personnel down to the platform.</p>
                <p>The rescue workers spray decontamination agents on the source to stop the spread.</p>
                <p>They then place modular deployable sensors around the station to reinforce the chemical network, monitor levels and ensure a final 'all clear' status.</p>`,
            step9: `
                <p>The HAZMAT team exits the station, having collected samples of the material.</p>
                <p>These samples are documented and packed into CBRN transport packaging, before being sealed and sent away to a laboratory for testing and analysis.</p>
                <p>The HAZMAT team then undergo decontamination.</p>`,
            step10: `
                <p>Following the all clear, people can be allowed to <span style="white-space: nowrap">re-enter</span> the station and return to normal.</p>`
        }
    },
    'civilian-biological': {
        subTitle: 'Threat scenario',
        title: 'Biological terrorist attack',
        steps: {
            intro: `
                <p>In this scenario – a terrorist event in a crowded metro station – we see how Saab’s complete CBRN solution comes together to coordinate support and ensure a joined-up response.</p>`,
            step1: `
                <p>An underground metro station during the busy morning rush hour.</p>
                <p>A terrorist, secretly carrying a canister, approaches and enters.</p>`,
            step2: `
                <p>Once on the platform, the terrorist covertly dumps a biological canister, before boarding a train and escaping the station.</p>
                <p>The canister starts to spread a biological substance.</p>
                <p>The station’s integrated sensors detect the threat right away and display what kind of substance the agent is. They transmit a signal to the Stationary Area Detection (SAD) system.</p>
                <p>An alarm is activated in the offsite control centre.</p>
                <p>Police come to the train station and enter, with hand-held sensors and gas mask on. Police seal off station.</p>`,
            step3: `
                <p>In the control centre, the operator receives on-screen information and step-by step guidance.</p>
                <p>Alerts are automatically transmitted to police, transport operators and the fire department.</p>
                <p>Rescue services arrive on the scene, and make sure the station is contained.</p>`,
            step4: `
                <p>The transport operator stops inbound and outbound trains to reduce the spread of the threat, and instructs people to leave the platform. </p>
                <p>The evacuated passengers are gathered into a temporary quarantine area.</p>
                <p>All those affected are isolated and treated to stop the spread of infection.</p>`,
            step5: `
                <p>The rescue agencies send in available teams, wearing protective suits.</p>
                <p>Right away the teams start to help injured people and transport them from the platform.</p>
                <p>The Personal Area Detection (PAD) system is used and is connected to the control centre.</p>`,
            step6: `
                <p>The HAZMAT team arrives to the scene and enters the station to take samples for identification.</p>
                <p>The team brings sampling equipment and chemical sensors to provide provisional identification of the substance.</p>`,
            step7: `
                <p>The Fire and Rescue department sends fast response personnel down to the platform.</p>
                <p>The rescue workers spray decontamination agents on the source to stop the spread.</p>`,
            step8: `
                <p>The HAZMAT team exits the station, having collected samples of the material.</p>
                <p>These samples are documented and packed into CBRN transport packaging, before being sealed and sent away to a laboratory for testing and analysis.</p>
                <p>The HAZMAT team then undergo decontamination.</p>`,
            step9: `
                <p>Following the all clear, people can be allowed to <span style="white-space: nowrap">re-enter</span> the station and return to normal.</p>`
        }
    },
    'civilian-radiological': {
        subTitle: 'Threat scenario',
        title: 'Radiological terrorist attack',
        steps: {
            intro: `
                <p>In this scenario – a terrorist event in a crowded metro station – we see how Saab’s complete CBRN solution comes together to coordinate support and ensure a joined-up response.</p>`,
            step1: `
                <p>An underground metro station during the busy morning rush hour.</p>
                <p>A terrorist walks towards the entrance of the train station, carrying a package containing a radioactive 'dirty bomb'.</p>`,
            step2: `
                <p>A detector at the station entrance detects increased gamma radiation levels.</p>
                <p>This triggers a radiological alarm. Information is then sent to the control centre.</p>`,            
            step3: `
                <p>In the control centre, the operator receives on-screen information and step-by-step guidance.</p>
                <p>Alerts are automatically transmitted to police, transport operators and the fire department.</p>
                `,
            step4: `
                <p>After receiving the automatic warning, police dispatch units equipped with hand-held sensors.</p>
                <p>They form a perimeter around the station, and seal off all entrances and exits.</p>
                <p>Medical teams arrive and prepare to receive evacuees.</p>
                `,
            step5: `
                <p>In the station, the transport operator slows down the movement of the escalators, decreasing the flow of people passing identification sensors.</p>
                <p>This makes it easier to pinpoint the person who carries the gamma source.</p>
                <p>When identified, the operator can follow the suspect on cameras and on CCTV.</p>
                `,
            step6: `
                <p>An alarm from a gamma sensor on the escalator identifies the gamma source. </p>
                <p>The train operator halts the escalator.</p>
                `,
            step7: `
                <p>The transport operator gives the location of the suspect.</p>
                <p>They then guide the police to them in order to make the arrest.</p>
                `,
            step8: `
                <p>Following the all clear, people can be allowed to <span style="white-space: nowrap">re-enter</span> the station and return to normal.</p>`
        }
    },
    'military': {
        subTitle: 'Threat scenario',
        title: 'Military gas attack',
        steps: {
            intro: `
                <p>In this scenario, we follow Saab’s advanced solution for threat detection, reporting and containment, which means soldiers in theatre can detect and contain a potential enemy CBRN risk before it can disrupt their supply route.</p>`,
            step1: `
                <p>A truck driving along a logistics route enters a contaminated area. It detects VX nerve gas using its onboard CBRN Automatic Warning and Reporting system.</p>`,
            step2:`
                <p>An automatic alert is sent out and a preliminary risk area established.</p>
                <p>Automatic alerts are instantly presented for all system installations in the sensor network before entering the risk area.</p>
                <p>Warnings and reports are exchanged with other coalition forces by way of the Command Area Detection (CAD).</p>`,
            step3:`
                <p>The driver turns on the onboard CBRN overpressuring system, sealing the vehicle and protecting occupants from the threat.</p>
                <p>Units in the risk area put on protective equipment and start the filter stations in their vehicles, as well as updating their dress code in order to protect themselves from a potential attack.</p>`,
            step4:`
                <p>CBRN experts from theatre level connect and verify functions and readings from MAD through the network.</p>
                <p>Information from other sensors in the Automatic Warning and Reporting system indicates no detection.</p>`,
            step5:`
                <p>RAD vehicles are sent out to confirm detection, survey the area, take samples with the Remote General Sampler and find alternate supply roads.</p>`,
            step6:`
                <p>A reduced risk area is calculated after the survey by the CBRN experts at HQ, supported by sensor readings from other chemical sensors in the area as well as weather data.</p>`,
            step7:`
                <p>Deployed Area Detection (DAD) sensors are placed out to verify and monitor the new risk area.</p>`,
            step8:`
                <p>The vehicle and all equipment are decontaminated before entering the base.</p>
                <p>The CBRN sample is removed from the RGS and put into the transport packaging, which is sealed and sent to the theatre level for validation. </p>
                `,
            step9:`
                <p>Dress code is lowered – there is no longer any need for respiratory protection.</p>
                <p>A new supply road is ordered.</p>
                <p>The area is monitored.</p>`,
        }
    },
    gallery: {
        military: [
            'military/Software.jpg',
            'military/_SKA9015.jpg',
            'military/_SKA9262_extended_blue_green.jpg',
            'military/_SKA9317.jpg',
            'military/_SKA9355.jpg',
            'military/AHTOE-514854.jpg',
            'military/MSP on car.jpg',
            'military/MSP on car2.jpg',
            'military/RAD Overpressure system.jpg',
            'military/RAD.jpg',
            'military/Recce Aea Detection3.jpg',
            'military/Recce Area Detection (RAD).jpg',
            'military/Recce Area Detection 4.jpg',
            'military/Recce Area Detection2.jpg',
            'military/RGS.jpg',
            'military/Saab-CBRN-web-2340-x-1557-px.jpg',
            'military/SAERO-514849-01-01_1.jpg',
            'military/SAERO-526451-01-01_1.jpg',
            'military/SAERO-552143-01-01.jpg',
            'military/Sand MSP.jpg',
            'military/sPAD1.jpg',
            'military/sPAD3.jpg',
            'military/sPAD4.jpg',
            'military/sPAD5.jpg',
            'military/Transport packaging1.jpg',
          ],
        chemical: [
            'chemical/_SKA9015.jpg',
            'chemical/_SKA9111 CBRN3B.jpg',
            'chemical/_SKA9123.jpg',
            'chemical/_SKA9136.jpg',
            'chemical/_SKA9262_extended_blue_green.jpg',
            'chemical/_SKA9271 CBRN2.jpg',
            'chemical/_SKA9317.jpg',
            'chemical/_SKA9355.jpg',
            'chemical/AHTOE-514854.jpg',
            'chemical/CBRN_example of sampling kits_2480x3507px.jpg',
            'chemical/MSP on car.jpg',
            'chemical/MSP on car2.jpg',
            'chemical/RAD.jpg',
            'chemical/Recce Aea Detection3.jpg',
            'chemical/Recce Area Detection (RAD).jpg',
            'chemical/Recce Area Detection 4.jpg',
            'chemical/Recce Area Detection2.jpg',
            'chemical/Saab-CBRN-web-2340-x-1557-px.jpg',
            'chemical/SAD.jpg',
            'chemical/SAERO-514849-01-01_1.jpg',
            'chemical/SAERO-526451-01-01_1.jpg',
            'chemical/SAERO-552143-01-01.jpg',
            'chemical/Sampling backpack.jpg',
            'chemical/Sand MSP.jpg',
            'chemical/Software.jpg',
            'chemical/sPAD1.jpg',
            'chemical/sPAD3.jpg',
            'chemical/sPAD4.jpg',
            'chemical/sPAD5.jpg',
            'chemical/Transport packaging1.jpg',
        ],
        biological: [
            'biological/Transport_packaging1.jpg',
            'biological/_SKA9015.jpg',
            'biological/_SKA9111_CBRN3B.jpg',
            'biological/_SKA9123.jpg',
            'biological/_SKA9136.jpg',
            'biological/_SKA9262_extended_blue_green.jpg',
            'biological/_SKA9271_CBRN2.jpg',
            'biological/_SKA9317.jpg',
            'biological/_SKA9355.jpg',
            'biological/AHTOE-514854.jpg',
            'biological/CBRN_example_of_sampling_kits_2480x3507px.jpg',
            'biological/RAD.jpg',
            'biological/Recce_Aea_Detection3.jpg',
            'biological/Recce_Area_Detection_(RAD).jpg',
            'biological/Recce_Area_Detection_4.jpg',
            'biological/Recce_Area_Detection2.jpg',
            'biological/SAD.jpg',
            'biological/SAERO-514849-01-01_1.jpg',
            'biological/SAERO-526451-01-01_1.jpg',
            'biological/SAERO-552143-01-01.jpg',
            'biological/Sampling_backpack.jpg',
            'biological/Software.jpg',
            'biological/sPAD1.jpg',
            'biological/sPAD3.jpg',
            'biological/sPAD4.jpg',
            'biological/sPAD5.jpg',
        ],
        radiological: [
            'radiological/Software.jpg',
            'radiological/SAD.jpg',
        ]
    }
};

export default globalDS;